import screenfull from 'screenfull';

const fullscreenHelper = {
  requestFullscreen: screenfull.request,
  exitFullscreen: screenfull.exit,

  /*
   * Return a boolean indicating if an element is in fullscreen mode.
   * Note: Fullscreen initialized by user at browser level will not be detected by this API
   */
  get inFullscreen() { return screenfull.isFullscreen; },

  addFullscreenChangeListener(handler, options) {
    screenfull.on('change', handler);
  },
  removeFullscreenChangeListener(handler) {
    screenfull.off('change', handler);
  },
};

export default fullscreenHelper;
